// Ordenação das categorias de serviços.
//
// As categorias não têm tabela própria — são apenas um campo de texto nos
// serviços. A ordem desejada é guardada como uma lista de nomes na chave
// `ordem_categorias` de `configuracoes` (key-value por tenant), em JSON.
//
// `ordenarCategorias` aplica essa ordem a uma lista de nomes de categoria:
// as que estão na ordem guardada aparecem primeiro (pela posição definida);
// as restantes (ex.: categorias novas ainda não ordenadas) vão para o fim,
// por ordem alfabética. Assim nada "desaparece" e o comportamento antigo
// (alfabético) mantém-se enquanto não houver ordem definida.

export function parseOrdemCategorias(valor) {
  if (!valor) return []
  try {
    const arr = JSON.parse(valor)
    return Array.isArray(arr) ? arr.filter(x => typeof x === 'string') : []
  } catch {
    return []
  }
}

export function ordenarCategorias(categorias, ordem) {
  const ordemArr = Array.isArray(ordem) ? ordem : parseOrdemCategorias(ordem)
  const indice = new Map(ordemArr.map((nome, i) => [nome, i]))
  return [...categorias].sort((a, b) => {
    const ia = indice.has(a) ? indice.get(a) : Infinity
    const ib = indice.has(b) ? indice.get(b) : Infinity
    if (ia !== ib) return ia - ib
    return a.localeCompare(b, 'pt')
  })
}
